<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card :title="$t('ShiftAdd') | ToUppercase">
        <small>{{ $t("Name") | ToUppercase }}</small><br>
        <vs-input class="w-full mb-6" type="text" name="name" v-model="shiftName"/>

        <div class="mt-5">
          <small>{{ $t("TimeFrom") | ToUppercase }}</small><br>
          <flat-pickr :config="configdateTimePicker" v-model="shiftTimeFrom" />
        </div>
        <div class="mt-5">
          <small>{{ $t("TimeTo") | ToUppercase }}</small><br>
          <flat-pickr :config="configdateTimePicker" v-model="shiftTimeTo" />
        </div>

        <div class="mt-5">
          <vs-button @click="addShift">{{ $t("Add") | ToUppercase }}</vs-button>
        </div>
        
      </vx-card>
    </div>
  </div>
</template>

<script>
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    export default {
    components: {
        flatPickr,
    },
    data: function () {
        return {
        shiftName: "",
        shiftTimeFrom: "",
        shiftTimeTo: "",

        configdateTimePicker: {
            enableTime: true,
            noCalendar: true,
            time_24hr: true,
        }
        };
    },
    created() {},
    methods: {
        addShift() {
            this.$vs.loading();

            const thisIns = this;
            this.$http.post("/shift/add", {
                name: thisIns.shiftName,
                timeFrom: thisIns.shiftTimeFrom,
                timeTo: thisIns.shiftTimeTo,
            }).then(function () {
                thisIns.$vs.notify({
                    text: "Izmena shranjena",
                    color: "success",
                });
                thisIns.$router.push('/shift/all');
            }).catch(function () {
                thisIns.$vs.notify({
                    text: "Napaka pri shranjevanju",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                });
            }).finally(function () {
                thisIns.$vs.loading.close();
            });
        },
    },
    filters: {
        ToUppercase: function (value) {
        if (!value) return "";
        value = value.toString();
        return value.toUpperCase();
        },
    },
    };
</script>